import { render, staticRenderFns } from "./AddEmployeeBasicDetailComponent.vue?vue&type=template&id=aa48a9e4&"
import script from "./AddEmployeeBasicDetailComponent.vue?vue&type=script&lang=js&"
export * from "./AddEmployeeBasicDetailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports